// extracted by mini-css-extract-plugin
export default {"about_container":"About_about_container__rV8da","right_item":"About_right_item__m2scg","left_item":"About_left_item__U8q0p","highlight":"About_highlight__5k9vn"};